import React from "react";
import { Info } from "@phosphor-icons/react";

export function Disclaimer({ compact = false }) {
  if (compact) {
    return (
      <p className="flex items-start gap-2 text-xs leading-relaxed text-slate-500" data-testid="disclaimer-compact">
        <Info size={14} weight="duotone" className="mt-0.5 shrink-0 text-slate-600" />
        TheInner.app is an educational and self-reflection tool. It is not therapy, medical advice, or a
        substitute for professional mental health care.
      </p>
    );
  }
  return (
    <div
      className="flex items-start gap-3 rounded-xl border border-slate-800 bg-slate-900/50 p-4"
      data-testid="disclaimer-box"
    >
      <Info size={18} weight="duotone" className="mt-0.5 shrink-0 text-amber-500/80" />
      <p className="text-xs leading-relaxed text-slate-500">
        <span className="font-semibold text-slate-400">A note on safety: </span>
        TheInner.app is an educational and self-reflection tool. It is not therapy, medical advice, or a
        substitute for professional mental health care. If you are in crisis or distress, please reach
        out to a licensed professional or a crisis line in your country.
      </p>
    </div>
  );
}
